<template>
  <div class="credit-panel" v-if="visible">
    <div class="cha" @click="$emit('update:visible', false)" />
    <el-form :model="form" label-width="80px" class="form">
      <el-form-item label="帐号：">
        <el-input v-model="form.email"></el-input>
      </el-form-item>
      <el-form-item label="密码：">
        <el-input v-model="form.password" type="password"></el-input>
      </el-form-item>
    </el-form>
    <div class="ft">
      <span class="btn-close" @click="login">登录</span>
    </div>
  </div>
</template>
<script>
import API from '../apis'
import { setToken, setEmail } from '../utils/user'

export default {
  name: 'LoginDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
      require: true
    }
  },
  data: function () {
    return {
      form: {
        email: '',
        password: ''
      }
    }
  },
  methods: {
    async login () {
      try {
        const { token, email, username } = await API.wbLogin(this.form)
        setToken(token)
        setEmail(email)
        this.$store.commit('LOGIN', {
          email,
          username
        })

        this.$emit('update:visible', false)
        this.$message.success('登录成功')
      } catch (e) {
        this.$message.error(e.msg || e.message)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.credit-panel {
  user-select: none;
  position: fixed;
  z-index: 10;
  left: 50%;
  top: 50%;
  width: 270px;
  margin: -180px 0 0 -172px;
  background: #fff;
  box-shadow:0px 6px 20px 0px rgba(222,225,240,0.54);
  .form {
    padding: 30px 40px 0 20px;
  }
  .ft {
    display: flex;
    margin-top: 20px;
    padding-bottom: 20px;
    .btn-close {
      display: block;
      width: 70px;
      height: 24px;
      margin: 0 auto;
      text-align: center;
      line-height: 24px;
      font-size: 12px;
      background: #4687ED;
      border-radius: 12px;
      color: #fff;
      cursor: pointer;
      &:hover {
        background: #5293FB;
      }
      &:active {
        background: #3E7EE3;
      }
    }
  }
}
.cha{
  width: 20px;
  height: 20px;
  margin: auto;
  position: absolute;
  right: 10px;
  top: 5px;
  cursor: pointer;
}
.cha::before,
.cha::after{
  content: "";
  position: absolute;  /*方便进行定位*/
  height: 15px;
  width: 1.5px;
  top: 2px;
  right: 9px;  /*设置top和right使图像在20*20框中居中*/
  background: #666;
}
.cha::before{
  transform: rotate(45deg);  /*进行旋转*/
}
.cha::after{
  transform: rotate(-45deg);
}
</style>
